import React, { useState, useEffect } from 'react';
import { authAPI } from '../../services/api';
import './KioskGuard.css';

const KioskGuard = ({ children }) => {
  const [accessGranted, setAccessGranted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('Verificando acesso...');

  useEffect(() => {
    const checkAccess = async () => {
      try {
        // Tenta verificar autenticação normal primeiro
        const token = localStorage.getItem('token');
        if (token) {
          setMessage('Verificando credenciais...');
          const response = await authAPI.verify();
          if (response.status === 'success') {
            setAccessGranted(true);
            setLoading(false);
            return;
          }
        }

        // Se não tem auth normal, verifica token de kiosk
        const urlParams = new URLSearchParams(window.location.search);
        const kioskToken = urlParams.get('token');
        
        if (kioskToken && validateKioskToken(kioskToken)) {
          setAccessGranted(true);
          setMessage('Acesso concedido...');
        } else {
          setAccessGranted(false);
          setMessage('Token inválido ou expirado');
        }
      } catch (error) {
        console.error('Erro na verificação:', error);
        setAccessGranted(false);
        setMessage('Erro na verificação de acesso');
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, []);

  if (loading) {
    return (
      <div className="kiosk-loading">
        <div className="loading-spinner"></div>
        <div className="loading-message">{message}</div>
      </div>
    );
  }

  if (!accessGranted) {
    return (
      <div className="kiosk-denied">
        <div className="denied-icon">🚫</div>
        <h2>Acesso Não Autorizado</h2>
        <p>Esta funcionalidade requer autenticação válida.</p>
        <p className="denied-detail">{message}</p>
        <div className="denied-actions">
          <button 
            onClick={() => window.location.href = '/'}
            className="btn-primary-kiosk"
          >
            Ir para Login
          </button>
          <button 
            onClick={() => window.close()}
            className="btn-secondary-kiosk"
          >
            Fechar Janela
          </button>
        </div>
      </div>
    );
  }

  return children;
};

const validateKioskToken = (token) => {
  try {
    const decoded = JSON.parse(atob(token));
    const now = Date.now();
    
    // Verificar se o token tem os campos necessários
    if (!decoded.timestamp || !decoded.userId) {
      return false;
    }
    
    // Token válido por 1 hora (3600000 ms)
    const validFor = 60 * 60 * 1000;
    const tokenAge = now - decoded.timestamp;
    
    return tokenAge < validFor;
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return false;
  }
};

export default KioskGuard;